export enum UserRole {
    ADMIN = 'admin',
    USER = 'user',
}

export interface User {
    id: string;
    username: string;
    facebookId?: string;
    name: string;
    email: string;
    profilePicture: string;
    isFacebookConnected: boolean;
    facebookName?: string;
    role?: UserRole;
    permissions?: string[];
}

export interface Page {
    id: string;
    pageId: string;
    name: string;
    category: string;
    pictureUrl: string;
    likes: number;
    createdAt: string;
}

export enum PostType {
    TEXT = 'text',
    PHOTO = 'photo',
    VIDEO = 'video',
    LINK = 'link',
}

export interface RelatedPost {
    id: string;
    postId: string;
    page: {
        id: string;
        name: string;
        pictureUrl: string;
    };
    status: 'pending' | 'published' | 'failed';
    errorMessage?: string;
    publishedAt: string;
}

export interface Post {
    id: string;
    postId: string;
    pageId: string | { _id: string; name: string; pictureUrl: string };
    content: {
        message: string;
        type: 'text' | 'photo' | 'link' | 'video';
        mediaUrl?: string;
        mediaUrls?: string[];
        link?: string;
    };
    stats: {
        likes: number;
        comments: number;
        shares: number;
    };
    sourcePostId?: string;
    status: 'pending' | 'published' | 'failed';
    errorMessage?: string;
    permalinkUrl?: string;
    source: 'synced' | 'app';
    relatedPosts?: RelatedPost[];
    publishedAt: string;
}

export interface AutoPostRule {
    id: string;
    sourcePageId: string;
    targetPageIds: string[];
    isActive: boolean;
    lastExecutedAt?: string;
}

export enum ProductStatus {
    IN_STOCK = 'in_stock',
    OUT_OF_STOCK = 'out_of_stock',
}

export interface ProductImage {
    url: string;
    isPrimary: boolean;
    filename?: string;
}

export interface Product {
    _id: string; // Using _id to match Mongoose
    name: string;
    description?: string;
    images: ProductImage[];
    price?: number;
    status: ProductStatus;
    quickMessages?: string[];
    userId: string;
    createdAt: string;
    updatedAt: string;
}

export interface CreateProductDto {
    name: string;
    description?: string;
    price?: number;
    status?: ProductStatus;
    images?: ProductImage[];
    quickMessages?: string[];
}
